import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { tagTypeSubscriptionsList_template } from "../components/templates/tagTypeSubscriptionsList_template";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class tag_type_subscriptions extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected elementsList: tagTypeSubscriptionsList_template;

    protected getModuleName(){

        return "tag_type_subscriptions";
    }

    buildContent() : Array<Element>{

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Tag Dataset Subscription");

        this.elementsList = new tagTypeSubscriptionsList_template("tag_type_subscriptions", this.viewModel, this);

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.elementsList.setIdBrand(idBrand);
        }

        this.filterList();
    }

    public showSelectableTags(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected tagsListReorder(){

        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel[this.getModuleName()].pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.tags;

        return templateViewModel;
    }

    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterList(){

        let subViewModel = this.elementsList.getViewModelForRequest();

        let req_url = `/api/brand/${this.getBrandId()}/tag/types/subscriptions/`;

        this.sendFilterCall(
            req_url,
            subViewModel,
            this.onFilterRequestReturn,
            XMLHttpRequestHandler_requestType.GET,
            'tag-type-subscriptions-list',
            this.elementsList.builtTemplate.children.namedItem("list-results")
        );
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){
                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed.data);
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));

                let execTime = Math.round((new Date().getTime() - req.requestStartTime)/1000*100)/100;
                obj.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage, execTime);
                obj.viewModel.tag_type_subscriptions.pagination.itemCount(responseParsed.totalCount);
            });
        }
    }

    protected add(){
        page(`/brand/${this.getVnAppZone().app.params.idBrand}/categorization/tag-type-subscriptions/add/`);
    }

    protected delete(dataset){
        let url = `/api/brand/${this.getVnAppZone().app.params.idBrand}/tag/types/subscriptions/delete/${dataset.id}/`;
        let params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.onReadyStateFunction = this.onDeleteReturn.bind(this);
        this.XHRHdl.execute();
    }

    protected onDeleteReturn(req, obj) {
        return function() {
            this.filterList();
        }.bind(this);
    }

    // update the module list using the objects list
    protected updateList(subscriptions: any){
        this.elementsList.getTemplateViewModel().subscriptions(subscriptions);
    }

    private getBrandId() {
        return this.getVnAppZone().getApp().params.idBrand;
    }
}


// WEBPACK FOOTER //
// ./js/modules/tag_type_subscriptions.ts